<template>
  <vx-card>
    <div class="vx-col">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <h3>Modifier un Type de Netlink</h3>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-button
            class="float-right"
            radius
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            @click="returnPrevRoute"
          ></vs-button>
        </div>
      </div>
      <div class="vx-row mt-4">
        <div class="vx-col w-full ">
          <vs-input
            v-model="netlinkType.name"
            placeholder="Nom du Type de Netlink"
            class="w-full"
            :style="styleValidator('name')"
          />
          <vx-tooltip v-if="validators['name'].errText !== ''" :text="errText('name')" class="ml-3">
            <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
          </vx-tooltip>
        </div>
      </div>
      <div class="vx-row mt-4">
        <div class="vx-col w-full ">
          <vs-select
            autocomplete
            v-model="netlinkType.recurrency"
            class="w-full select-large mt-4"
            placeholder="Récurrence"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in recurrencyOptions"
              class="w-full"
            />
          </vs-select>
        </div>
      </div>
      <div class="vx-row mt-4">
        <div class="vx-col w-full ">
          <vs-select
            autocomplete
            v-model="netlinkType.is_dns"
            class="w-full select-large mt-4"
            placeholder="Est NDD ?"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in isDnsOptions"
              class="w-full"
            />
          </vs-select>
        </div>
      </div>
      <div class="vx-row mt-4">
        <div class="vx-col w-full mb-2">
		  <label for="" class="vs-select--label">Description</label>
          <vs-textarea
            v-model="netlinkType.description"
            label="Description"
            class="mb-0"
            rows="1"
            :style="styleValidator('description')"
          />
          <vx-tooltip v-if="validators['description'].errText !== ''" :text="errText('description')" class="ml-3">
            <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
          </vx-tooltip>
        </div>
      </div>
      <!-- <div class="vx-row mt-2">
        <div class="vx-col w-full ">
          <vs-checkbox class="inline-flex mt-4" v-model="product.isNetlink"
            >Est un produit de type Netlink</vs-checkbox
          >
        </div>
      </div> -->
      <div class="vx-row mt-3 right_element">
        <div class="vx-col">
          <!-- <vs-button
            color="warning"
            type="border"
            class="mb-2 mr-3"
            @click="resetForm(product)"
            >Réinitialiser</vs-button
          > -->
          <vs-button class="mb-2" @click="formSubmitted">Enregistrer</vs-button>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import utilsMixin from "@/mixins/utilsMixin";
// import store from "@/store/store";

export default {
	name: "UpdateNetlinkTypeForm",
	props: {
		chartParams: Object,
		isPercent: Boolean
	},
	mixins: [utilsMixin],
	data() {
		return {
			// PRODUCT OBJECT
			netlinkType: {
				name: "",
				recurrency: 0,
				is_dns: 0,
				description: ""
			},
			netlinkTypeOld: {
				name: "",
				recurrency: 0,
				is_dns: 0,
				description: ""
			},
			apiUrl: this.$store.state.backendApiUrl,
			// FORM SELECT OPTIONS
			recurrencyOptions: [
				{value: 0, text: "Non Récurrent"},
				{value: 1, text: "Récurrent"},
			],
			isDnsOptions: [
				{value: 0, text: "Non"},
				{value: 1, text: "Oui"},
			],
			validators: {
				name: {
					errText: ""
				},
				recurrency: {
					errText: ""
				},
				is_dns: {
					errText: ""
				},
				description: {
					errText: ""
				}
			},
			check: true
		};
	},
	created() {
		//GET
		this.$http.get(this.apiUrl + "netlink/type/get/" + this.$route.params.netlinkTypeId)
			.then(netlinkType => {
				this.netlinkType = netlinkType.data[0];
				this.netlinkTypeOld = netlinkType.data[0];
			})
			.catch(err => {
				//console.log(err);
			});
	},
	methods: {
		errText(name){
			if(this.validators[name].errText !== ""){
				return this.validators[name].errText;
			}
		},
		styleValidator(name){
			if(this.validators[name].errText !== ""){
				return "border: 1px solid red !important; border-radius: 5px;";
			}
			else if(this.validators[name].errText == ""){
				return "border: 1px solid green !important; border-radius: 5px;";
			}
			else{
				return "border: none !important; border-radius: none;";
			}
		},
		/**
		 * Send the data to tha API to create the new user
		 */
		formSubmitted(){
			this.check = true;
			let fields = ["name"];
			for(let i = 0; i < fields.length; i++){
				if(this.netlinkType[fields[i]] == "" || this.netlinkType[fields[i]] == null){
					this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
					this.check = false;
				}
				else{
					this.validators[fields[i]].errText = "";
				}
			}
			this.$forceUpdate();

			if(this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs."
				});
				return;
			}
			this.$http.post(this.apiUrl + "netlink/type/edit", {
				id: this.$route.params.netlinkTypeId,
				name: this.netlinkType.name,
				recurrency: this.netlinkType.recurrency,
				is_dns: this.netlinkType.is_dns,
				description: this.netlinkType.description
			});
			// Send a success notification to the user
			this.$vs.notify({
				title: "Succès",
				text: "Prestation mise à jour avec succès."
			});
			this.$store.dispatch("getAllNetlinkTypes");
			// Send the user to the previous route
			this.$router.go(-1);
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		}
	}
};
</script>

<style scoped>
.role_selector_container {
  justify-content: space-between;
  width: 40%;
}

.role_container {
  justify-content: center;
}

.space_div {
  margin: 5px;
}

.right_element {
  justify-content: flex-end;
}

.bottom {
  align-self: flex-end;
}

.center {
  align-self: center;
}
</style>
